export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conformité devoir de conseil"])},
        "region_rate_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Taux :"])},
        "target_100": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["objectif 100%"])},
        "stores_below_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Magasins < 90%"])},
        "reminder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rappel : une vente non conforme n'est pas rémunérée."])},
        "all_compliant": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tous les magasins sont conformes, excellent !"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Duty of advice compliance"])},
        "region_rate_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rate:"])},
        "target_100": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["target 100%"])},
        "stores_below_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stores < 90%"])},
        "reminder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reminder: a non-compliant sale is not paid."])},
        "all_compliant": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All stores are compliant, excellent!"])}
      }
    }
  })
}
